<template>
  <section class="checkout-section">
    <div class="checkout-section__header">
      <h2 class="checkout-section__title">{{data.flights.title}}</h2>
      <div class="checkout-section__description" v-html="data.flights.descriptionHtml"></div>
    </div>

    <YourHoliday :departureDetails="departureDetails" />

    <div class="checkout-section__footer">
      <NavButton :back="true" text="Back" />
      <NavButton @beforeNextStep="handleContinueClick" />
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import YourHoliday from '@/vue/components/Tour/YourHoliday.vue';
import NavButton from './../Components/NavButton.vue';
import {Brand} from './../../../../brand.js';

export default {
  name: 'Flights',

  components: {
    YourHoliday,
    NavButton
  },

  data: function() {
    return {
      Brand
    };
  },

  computed: mapState('checkout', ['departureDetails', 'data']),

  methods: {
    handleContinueClick() {
      this.$store.commit("checkout/setAddons", this.$store.state.checkout);
      GTM.addTourExtension(this.$store.state.checkout);
    }
  }
};
</script>
